// Per-call event de-duplication for the call-control resume (modules/05 §4): the client
// tracks the highest seq applied per call and drops any event with seq <= lastSeq (a
// replay that overlaps live delivery is harmless). Pure + unit-tested.

export class EventTracker {
  private readonly lastSeq = new Map<number, number>();

  /** Returns true if the event should be applied; records it as the new high-water mark. */
  shouldApply(callId: number, seq: number): boolean {
    if (seq <= 0) return true; // non-sequenced (e.g. presence seq=0) — always applied
    const last = this.lastSeq.get(callId) ?? 0;
    if (seq <= last) return false; // duplicate / already-seen on replay
    this.lastSeq.set(callId, seq);
    return true;
  }

  lastSeqFor(callId: number): number {
    return this.lastSeq.get(callId) ?? 0;
  }

  reset(callId: number): void {
    this.lastSeq.delete(callId);
  }
}
